










export default

	props:

		# Main prop for use by CMS
		block: Object

		# Convenience prop for use in Vue templates
		height: String

	computed:

		computedHeight: -> @height or @block?.height

		# Root classes
		classes: -> "height-#{@computedHeight}"

